import { render, staticRenderFns } from "./publicFiles.vue?vue&type=template&id=2ef05d92&"
import script from "./publicFiles.vue?vue&type=script&lang=js&"
export * from "./publicFiles.vue?vue&type=script&lang=js&"
import style0 from "./publicFiles.vue?vue&type=style&index=0&id=2ef05d92&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports